<template>
    <div class="wb-sidebar-menu-line-three">
        <div class="wb-sidebar-menu-price">
          {{price}} {{this.currencySymbol}}
        </div>
        <SidebarMenuItemCounter
            @count-del="delCount"
            @count-add="addCount"
            :value="storeData.categoriesItems[data.id] ?? 0"
        />
        <SidebarMenuItemCatalog/>
    </div>
</template>

<script>
import SVGDragNDrop from '@/UI/Components/SVG/SVGDragNDrop.vue';
import SidebarMenuItemCounter from '@/UI/Components/ComponentsSidebarMenu/SidebarMenuItemCounter.vue';
import SidebarMenuItemCatalog from '@/UI/Components/ComponentsSidebarMenu/SidebarMenuItemCatalog.vue';
import { useStoreData } from '@/Store/storeData';

export default {
    name: 'SidebarMenuItemBot2',
    components: { SidebarMenuItemCatalog, SidebarMenuItemCounter, SVGDragNDrop },
    props: [
        'price',
        'count',
        'data',
        'currencySymbol'
    ],
  setup() {
    const storeData = useStoreData();

    return{
      storeData,
    };
  },
    methods: {
      addCount() {
        this.storeData.setCategoriesItems(this.data.id, +1);
        this.storeData.setZeroPrice(this.price != 0);
      },
      delCount() {
        this.storeData.setCategoriesItems(this.data.id, -1);
      },
    },
};
</script>

<style scoped lang="scss">
@import "CSS/fonts.scss";
@import "CSS/colors.scss";
@import "CSS/animations.scss";
@import "CSS/common.scss";

.wb-sidebar-menu-line-three {
    display: grid;
    grid-template-columns: auto max-content max-content;
    grid-column-gap: 8px;
    width: 100%;
}

.wb-dnd-on-hover-anchor {
    width: 0;
}

.wb-dnd-on-hover-visible {
    //display: none;
    position: relative;
    right: 24px;
    color: transparent;
    @include button-smooth;
}

.wb-sidebar-menu-item:hover .wb-dnd-on-hover-visible{
    color: $green2;
}

</style>
